module.exports = __webpack_public_path__ + "static/media/EnergyExtortion.f9ebd96a.jpg";